import { render, staticRenderFns } from "./VFormDisplay.vue?vue&type=template&id=36ca9aa4&scoped=true&"
import script from "./VFormDisplay.vue?vue&type=script&lang=js&"
export * from "./VFormDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca9aa4",
  null
  
)

export default component.exports